import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, TextCharLimit, Button} from 'views/components';
import {translate, Translate} from 'views/module';

const Content = (props) => {
  const [questionTitle, setQuestionTitle] = React.useState('');
  const [isSaving, setIsSaving] = React.useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = React.useState(true);

  const careviewItem = props.careviewItem;
  const setViewMode = props.setViewMode;
  const updateQuestion = props.updateQuestion;

  React.useEffect(() => {
    setQuestionTitle(careviewItem.questionData.questionTitle);
  }, [careviewItem]);

  React.useEffect(() => {
    setIsSaveDisabled(!questionTitle.trim().length);
  }, [questionTitle]);

  const onSave = () => {
    setIsSaving(true);
    const updatedCareviewItem = {
      ...careviewItem.questionData,
      questionTitle: questionTitle,
    };
    const onSuccess = () => {
      setIsSaving(false);
      setViewMode();
    };
    updateQuestion(updatedCareviewItem, onSuccess);
  };

  return (
    <Box>
      <TextCharLimit
        label={translate('client.ClientDetail.CareviewSettings.Types.FiveStar.Question')}
        placeholder={translate('client.ClientDetail.CareviewSettings.Types.FiveStar.Question')}
        value={questionTitle}
        onChange={setQuestionTitle}
        charLimit={180}
        autoFocus
        fullWidth
      />
      <Stack
        direction={'row'}
        spacing={1}
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Button
          variant='outlined'
          onClick={setViewMode}
        >
          <Translate expression='client.ClientDetail.CareviewSettings.Types.Actions.Cancel' />
        </Button>
        <Button
          loading={isSaving}
          onClick={onSave}
          disabled={isSaveDisabled}
        >
          <Translate expression='client.ClientDetail.CareviewSettings.Types.Actions.Save' />
        </Button>
      </Stack>
    </Box>
  );
};

Content.propTypes = {
  careviewItem: PropTypes.object.isRequired,
  updateQuestion: PropTypes.func.isRequired,
  setViewMode: PropTypes.func.isRequired,
};
export default React.memo(Content);
